<template>
  <div class="page">
    <div class="head-title">
      <div class="left">
        <ul class="breadcrumb">
          <li>
            <router-link to="/sales/home" class="active">{{
              $t("sales")
            }}</router-link>
          </li>
          <li>-</li>
          <li>
            <router-link to="/sales/AllReceipts" class="active">{{
              $t("receipts")
            }} {{ $t("customers") }}</router-link>
          </li>
          <li>-</li>
          <li>
            <a class="active" href="#">
              {{ $t("receipt") }} {{ $t("customers") }} - PYT-{{
                alldata2.rid
              }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="main">
      <div class="head">
        <div class="head1">
          <h3>
            {{ $t("receipt") }} {{ $t("customers") }} - PYT-{{ alldata2.rid }}
          </h3>
        </div>
        <div class="head2">
          <div class="button-group">
            <button
              class="button button--confirm"
              type="submit"
              @click="confirm"
              v-if="alldata2.review === 'waiting'"
            >
              <i class="bi bi-file-check-fill"></i> {{ $t("confirm") }}
            </button>
            <button class="button button--print" type="submit" @click="print2">
              <i class="bi bi-printer-fill"></i> {{ $t("printer") }}
            </button>
            <button class="button button--pdf" type="submit" @click="pdf">
              <i class="bi bi-filetype-pdf"></i> {{ $t("PDF") }}
            </button>
            <button
              class="button button--download"
              type="submit"
              v-if="alldata2.fileurl"
            >
              <a :href="alldata2.fileurl" target="_blank">
                <i class="bi bi-download"></i> {{ $t("download") }} {{ $t("file") }}
              </a>
            </button>
            <button class="button button--cancel" type="submit" @click="back">
              {{ $t("cancel") }}
            </button>
          </div>
        </div>
      </div>
      <div class="body">
        <div class="part1">
          <div class="part11">
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{
                $t("number")
              }}</label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  PYT-{{ alldata2.rid }}
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{
                $t("date")
              }}</label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.due }}
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{
                $t("description")
              }}</label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.description }}
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{
                $t("type")
              }}</label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.type }}
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{
                $t("amount")
              }}</label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.amount }}
                </div>
              </div>
            </div>
            <div class="mb-2 row" v-if="alldata2.recremaining > 0">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{
                $t("remaining")
              }}</label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.recremaining }}
                </div>
              </div>
            </div>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{
                $t("Account")
              }}</label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.namear }}
                </div>
              </div>
            </div>
            <div class="mb-2 row" v-if="alldata2.projectname">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{
                $t("project")
              }}</label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.projectname }}
                </div>
              </div>
            </div>
            <div class="mb-2 row" v-if="alldata2.task">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{
                $t("task")
              }}</label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.task }}
                </div>
              </div>
            </div>
            <div class="mb-2 row" v-if="alldata2.contractorname">
              <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{
                $t("contractor")
              }}</label>
              <div class="col-sm-7">
                <div class="form-control form-control-sm">
                  {{ alldata2.contractorname }}
                </div>
              </div>
            </div>
          </div>
          <div class="part11">
            <h4>{{ $t("data") }} {{ $t("customer") }}</h4>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">{{
                $t("name")
              }}</label>
              <div class="col-sm-7">{{ alldata2.cname }}</div>
            </div>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">{{
                $t("mobile")
              }}</label>
              <div class="col-sm-7">{{ alldata2.cmobile }}</div>
            </div>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">{{
                $t("email")
              }}</label>
              <div class="col-sm-7">{{ alldata2.cmail }}</div>
            </div>
            <div class="mb-2 row">
              <label for="inputEmail3" class="col-sm-3 col-form-label-sm">{{
                $t("tax")
              }}</label>
              <div class="col-sm-7">{{ alldata2.ctax }}</div>
            </div>
          </div>
        </div>
        <div class="part2" v-if="details.length > 0">
          <h4>{{ $t("invoices") }} {{ $t("customer") }}</h4>
          <table class="table">
            <thead>
              <tr>
                <th>{{ $t("number") }} {{ $t("invoice") }}</th>
                <th>{{ $t("date") }}</th>
                <th>{{ $t("amount") }}</th>
                <th>{{ $t("received") }}</th>
                <th>{{ $t("amount") }}</th>
                <th>{{ $t("remaining") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="val in details" :key="val">
                <td>
                  <router-link :to="`/sales/InvoiceView/${val.invid}`">
                    INV-{{ val.invid }}
                  </router-link>
                </td>
                <td>{{ val.due }}</td>
                <td>{{ val.tat }}</td>
                <td>{{ val.payment }}</td>
                <td>{{ val.amount }}</td>
                <td>{{ val.change }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td></td>
                <td>{{ totalamount }}</td>
                <td>{{ totalreceived }}</td>
                <td>{{ totalpaid }}</td>
                <td>{{ totalremaining }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <hr />
        <div class="user">
          <i class="bi bi-eye-fill"></i> {{ $t("created") }} {{ $t("by") }} :
          {{ alldata2.username }}
          <div class="udate">
            {{ $t("date") }} : {{ alldata2.date }} - {{ $t("time") }} :
            {{ alldata2.time }}
          </div>
        </div>
        <div class="user" v-if="alldata2.review === 'confirmed'">
          <i class="bi bi-eye-fill"></i> {{ $t("confirmed") }} {{ $t("by") }} :
          {{ alldata2.reviewusername }}
          <div class="udate">
            {{ $t("date") }} : {{ alldata2.reviewdate }} - {{ $t("time") }} :
            {{ alldata2.reviewtime }}
          </div>
        </div>
        <div class="user" v-if="alldata2.review === 'cancel'">
          <i class="bi bi-eye-fill"></i> {{ $t("cancel") }} {{ $t("by") }} :
          {{ alldata2.reviewusername }}
          <div class="udate">
            {{ $t("date") }} : {{ alldata2.reviewdate }} - {{ $t("time") }} :
            {{ alldata2.reviewtime }}
          </div>
        </div>
        <div class="user" v-if="alldata2.finusername">
          <i class="bi bi-eye-fill"></i> {{ $t("financial") }} {{ $t("by") }} :
          {{ alldata2.finusername }}
          <div class="udate">
            {{ $t("date") }} : {{ alldata2.findate }} - {{ $t("time") }} :
            {{ alldata2.fintime }}
          </div>
        </div>
      </div>
      <div id="main" style="padding: 2%; display: none">
        <div style="padding: 2%; direction: rtl; font-size: small">
          <img
            :src="this.url"
            crossorigin="anonymous"
            style="height: 100px; width: 25%; float: right"
          />
          <div class="part1" style="clear: both">
            <div class="part11">
              <h3>{{ $t("receipt") }} {{ $t("customers") }}</h3>
              {{ $t("number") }} : PYT-{{ alldata2.rid }} {{ $t("date") }} :
              {{ alldata2.due }} / {{ alldata2.time }}
              <br />
            </div>
            <br />
            <div class="part12">
              <div style="padding: 2%">
                <h5>{{ this.$store.state.cnum[0].cname }}</h5>
                {{ this.$store.state.cnum[0].caddress }}
                <br />
                {{ $t("tax") }} : {{ this.$store.state.cnum[0].taxnum }}
              </div>
            </div>
            <div class="part12">
              <div style="padding: 2%">
                {{ $t("name") }} :
                <h5>{{ alldata2.cname }}</h5>
                {{ $t("address") }} : {{ alldata2.caddress }}
                <br />
                {{ $t("tax") }} : {{ alldata2.ctax }}
              </div>
            </div>
          </div>
          <br />
          <div class="part2">
            <table style="width: 100%; text-align: center; font-size: small">
              <thead>
                <tr style="height: 50px">
                  <th style="border: 0.5px solid black">{{
                    $t("description")
                  }}</th>
                  <th style="border: 0.5px solid black">{{ $t("type") }}</th>
                  <th style="border: 0.5px solid black">{{ $t("amount") }}</th>
                  <th style="border: 0.5px solid black">{{ $t("remaining") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="border: 0.5px solid black">
                    {{ alldata2.description }}
                  </td>
                  <td style="border: 0.5px solid black">{{ alldata2.type }}</td>
                  <td style="border: 0.5px solid black">{{ alldata2.amount }}</td>
                  <td style="border: 0.5px solid black">
                    {{ alldata2.recremaining }}
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="details.length > 0">
                <tr>
                  <td colspan="4">
                    <hr />
                  </td>
                </tr>
                <tr style="height: 50px">
                  <td colspan="2"></td>
                  <td style="border: 0.5px solid black">
                    {{ $t("total") }} {{ $t("amount") }}
                  </td>
                  <td style="border: 0.5px solid black">{{ totalpaid }}</td>
                </tr>
                <tr style="height: 50px">
                  <td colspan="2"></td>
                  <td style="border: 0.5px solid black">
                    {{ $t("total") }} {{ $t("remaining") }}
                  </td>
                  <td style="border: 0.5px solid black">{{ totalremaining }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="part2" v-if="details.length > 0">
            <h4>{{ $t("invoices") }} {{ $t("customer") }}</h4>
            <table style="width: 100%; text-align: center; font-size: small">
              <thead>
                <tr style="height: 50px">
                  <th style="border: 0.5px solid black">
                    {{ $t("number") }} {{ $t("invoice") }}
                  </th>
                  <th style="border: 0.5px solid black">{{ $t("date") }}</th>
                  <th style="border: 0.5px solid black">{{ $t("amount") }}</th>
                  <th style="border: 0.5px solid black">{{ $t("received") }}</th>
                  <th style="border: 0.5px solid black">{{ $t("amount") }}</th>
                  <th style="border: 0.5px solid black">{{ $t("remaining") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="val in details" :key="val">
                  <td style="border: 0.5px solid black">INV-{{ val.invid }}</td>
                  <td style="border: 0.5px solid black">{{ val.due }}</td>
                  <td style="border: 0.5px solid black">{{ val.tat }}</td>
                  <td style="border: 0.5px solid black">{{ val.payment }}</td>
                  <td style="border: 0.5px solid black">{{ val.amount }}</td>
                  <td style="border: 0.5px solid black">{{ val.change }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr />
          {{ $t("description") }} : {{ alldata2.description }}
          <br />
          <div v-if="alldata2.projectname">
            {{ $t("project") }} : {{ alldata2.projectname }}
            <br />
          </div>
          <div v-if="alldata2.task">
            {{ $t("task") }} : {{ alldata2.task }}
            <br />
          </div>
          <div v-if="alldata2.contractorname">
            {{ $t("contractor") }} : {{ alldata2.contractorname }}
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import html2pdf from "html2pdf.js";

export default {
  props: ["css"],
  data() {
    return {
      alldata2: "",
      details: [],
      url: "",
      totalamount: 0,
      totalreceived: 0,
      totalpaid: 0,
      totalremaining: 0,
    };
  },
  async mounted() {
    try {
      const response = await axios.get(`/data/receiptview/${this.$route.params.id}`);
      if (response.status === 200) {
        const data = response.data.data[0];
        this.alldata2 = data;
        if (data.details) {
          this.details = JSON.parse(data.details);
          this.totalamount = this.details.reduce(
            (acc, array) => acc + Number(array.tat),
            0
          ).toFixed(2);
          this.totalreceived = this.details.reduce(
            (acc, array) => acc + Number(array.payment),
            0
          ).toFixed(2);
          this.totalpaid = this.details.reduce(
            (acc, array) => acc + Number(array.amount),
            0
          ).toFixed(2);
          this.totalremaining = this.details.reduce(
            (acc, array) => acc + Number(array.change),
            0
          ).toFixed(2);
        }
        this.url = `${store.state.imgurl}/clogo/${store.state.cnum[0].cnum}.png`;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load receipt data.",
      });
    }
  },
  methods: {
    back() {
      this.$root.$router.push({
        path: "/sales/AllReceipts",
      });
    },
    async confirm() {
      Swal.fire({
        title: `${this.$t("confirm")} ${this.$t("receipt")} ${this.$t("customers")} PYT-${this.alldata2.rid}`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("confirm"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post("/data/confirmreceipt", {
              id: this.alldata2.rid,
              cnum: store.state.cnum[0].cnum,
              details: this.details,
              username: store.state.randp.username,
            });
            if (response.status === 200) {
              Swal.fire({
                icon: "success",
                title: `${this.$t("confirm")} ${this.$t("receipt")} ${this.$t("customers")} PYT-${this.alldata2.rid}`,
                text: "Receipt confirmed successfully.",
              });
              this.redirectTo({ val: "AllReceipts" });
            }
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Failed to confirm receipt.",
            });
          }
        }
      });
    },
    pdf() {
      html2pdf(document.getElementById("main").innerHTML, {
        margin: 0.5,
        filename: `PYT-${this.alldata2.rid}.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      });
    },
    print2() {
      this.$htmlToPaper("main");
    },
    ...mapActions(["redirectTo"]),
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 0.5%;
}

.main {
  width: 98%;
  margin: 1%;
  padding: 1%;
  border-radius: 5px;
  border: ridge 0.5px;
}

.head {
  padding: 0.25%;
  display: flex;
  border-bottom-style: ridge;
}

.head1 {
  width: 50%;
}

input {
  margin: 0.5%;
  padding: 0.5%;
  border: none;
  border-radius: 5px;
  background-color: #eee;
  text-align: center;
}

.head2 {
  width: 50%;
  text-align: center;
}

button {
  margin: 0.5%;
  padding: 2%;
  border: none;
  border-radius: 5px;
  background-color: rgba(98, 153, 174, 255);
  color: white;
}

.table {
  margin-top: 1%;
  text-align: center;
}

table thead tr {
  border-radius: 5px;
  background-color: #eee;
}

.part1 {
  display: flex;
  width: 100%;
}

.part11 {
  width: 50%;
  padding: 2%;
}

@media screen and (max-width: 576px) {
  .table {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
    background-color: white;
    font-size: xx-small;
  }
}

.head2 {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: flex-end;
  padding: 0.5rem 0;

  button,
  .btn-primary {
    --btn-padding-x: 1.5rem;
    --btn-padding-y: 0.75rem;
    --btn-icon-size: 1.1rem;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    padding: var(--btn-padding-y) var(--btn-padding-x);
    border-radius: 0.5rem;
    font-weight: 500;
    font-size: 0.925rem;
    line-height: 1;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid transparent;
    min-width: 120px;

    &:not(:disabled):hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    &:not(:disabled):active {
      transform: translateY(0);
      filter: brightness(0.95);
    }

    i {
      font-size: var(--btn-icon-size);
      transition: transform 0.2s ease;
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none !important;
    }

    a {
      color: white;
      text-decoration: none;
    }
  }

  .button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: flex-end;
  }
}

.button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }

  i {
    font-size: 1.1em;
  }
}

.button--confirm {
  background-color: #4caf50;
  color: white;

  &:hover {
    background-color: #45a049;
  }
}

.button--print {
  background-color: #2196f3;
  color: white;

  &:hover {
    background-color: #1976d2;
  }
}

.button--pdf {
  background-color: #9c27b0;
  color: white;

  &:hover {
    background-color: #7b1fa2;
  }
}

.button--download {
  background-color: #009688;
  color: white;

  &:hover {
    background-color: #00796b;
  }
}

.button--cancel {
  background-color: #f44336;
  color: white;

  &:hover {
    background-color: #d32f2f;
  }
}

@media (max-width: 768px) {
  .button-group {
    justify-content: center;
  }

  .button {
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
  }
}
</style>
